var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, } from "react";
import { navigate } from "@reach/router";
import useLoaderButton from "../LoaderButton/useLoaderButton";
import { InputText } from "../InputText";
import { InputLabel } from "../InputLabel";
import { InputGroup } from "../InputGroup";
import { AnchorLink } from "../AnchorLink";
import { useNotificationsCtx } from "../NotificationStack/useNotificationsCtx";
import { TNotificationType } from "../NotificationStack/NotificationTypes";
import { LoginFormStyled } from "./LoginFormStyled";
var LoginForm = function (_a) {
    var _b = _a.hideRegister, hideRegister = _b === void 0 ? false : _b, _c = _a.registerRoute, registerRoute = _c === void 0 ? "/register" : _c, _d = _a.hideForgot, hideForgot = _d === void 0 ? false : _d, _e = _a.forgotRoute, forgotRoute = _e === void 0 ? "/forgot" : _e, setTokenData = _a.setTokenData, login = _a.login, _f = _a.redirectTo, redirectTo = _f === void 0 ? "/" : _f;
    var addNotification = useNotificationsCtx().addNotification;
    var _g = useState(""), email = _g[0], setEmail = _g[1];
    var _h = useState(""), password = _h[0], setPassword = _h[1];
    var _j = useLoaderButton(), LoaderButton = _j.LoaderButton, enableButton = _j.enableButton, setLoadingButton = _j.setLoadingButton;
    var handleSubmit = useCallback(function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var tokenData, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ev.preventDefault();
                    if (!(email.trim() !== "" || password.trim() !== "")) return [3, 5];
                    setLoadingButton();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, login(email, password)];
                case 2:
                    tokenData = _b.sent();
                    setTokenData && setTokenData(tokenData);
                    navigate(redirectTo);
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    addNotification("There was an error trying to log in.", TNotificationType.error);
                    enableButton();
                    return [3, 4];
                case 4: return [3, 6];
                case 5:
                    addNotification("Please enter your username and email.", TNotificationType.error);
                    _b.label = 6;
                case 6: return [2];
            }
        });
    }); }, [
        addNotification,
        email,
        enableButton,
        login,
        password,
        redirectTo,
        setLoadingButton,
        setTokenData,
    ]);
    var onKeyPress = useCallback(function (ev) {
        if (ev.key === "Enter") {
            ev.preventDefault();
            handleSubmit(ev);
        }
    }, [handleSubmit]);
    return (React.createElement(LoginFormStyled, null,
        React.createElement("div", { className: "controls" },
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, { htmlFor: "email" }, "Email:"),
                React.createElement(InputText, { type: "text", name: "email", value: email, onChange: function (ev) {
                        setEmail(ev.target.value);
                    }, onKeyPress: onKeyPress })),
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, { htmlFor: "password" }, "Password:"),
                React.createElement(InputText, { type: "password", name: "password", value: password, onChange: function (ev) {
                        setPassword(ev.target.value);
                    }, onKeyPress: onKeyPress }))),
        React.createElement("div", { className: "actions" },
            React.createElement("div", { className: "secondary-actions" },
                !hideForgot && (React.createElement(AnchorLink, { to: forgotRoute }, "Forgot your password?")),
                !hideRegister && (React.createElement(AnchorLink, { to: registerRoute }, "Register Here"))),
            React.createElement(LoaderButton, { className: "loader-button", onClick: handleSubmit },
                React.createElement(React.Fragment, null, "Sign In")))));
};
export default LoginForm;
//# sourceMappingURL=LoginForm.js.map